import { Box, CircularProgress, IconButton } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { msg } from '@lingui/macro';
import { masterHasMergeSources } from './crash-list-nested-rows.helper';

export function buildValidatedExpandColumn(options) {
  const {
    translate,
    isMasterExpanded,
    isMasterLoading,
    isMasterExpandDisabled,
    onToggleExpand,
  } = options;

  return {
    field: 'validated_expand',
    headerName: '',
    width: 36,
    minWidth: 36,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    headerClassName: 'overload-theme--header',
    rowSpanValueGetter: (value, row) => (row ? row['Crash id'] : null),
    renderCell: (params) => {
      const masterCrashId = String(params.row['Crash id'] ?? '');
      if (
        params.row?.isMergeSourceChild
        || !masterHasMergeSources(params.row)
        || isMasterExpandDisabled(masterCrashId)
      ) {
        return null;
      }
      const isExpanded = isMasterExpanded(masterCrashId);
      const isLoading = isMasterLoading(masterCrashId);
      const expandLabel = isExpanded
        ? translate(msg`Collapse source crashes`)
        : translate(msg`Expand source crashes`);

      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
          {isLoading ? (
            <CircularProgress size={16} aria-label={translate(msg`Loading source crashes`)} />
          ) : (
            <IconButton
              size="small"
              aria-label={expandLabel}
              aria-expanded={isExpanded}
              onClick={(event) => {
                event.stopPropagation();
                onToggleExpand(masterCrashId);
              }}
            >
              {isExpanded ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
            </IconButton>
          )}
        </Box>
      );
    },
  };
}
